import './polyfills';
import React from 'react';
import { render } from 'react-dom';
import ReactGA from 'react-ga';

import ErrorBoundary from './components/ErrorBoundary';
import App from './components/App';
import parseQueryString from './utils/querystring';
import { DisabledAppError } from './errors';
import ConfigService from './services/config';
import DataService from './services/data';

ReactGA.initialize(process.env.GA_TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

const main = () => {
  const configKey = parseQueryString(document.location.search)['config'];

  render(<div></div>, document.getElementById('app'));

  try {
    ConfigService.getConfig(configKey)
      .then(config => {
        if (config.disabled) {
          setTimeout(() => {
            main();
          }, 2 * 60 * 1000);

          throw new DisabledAppError();
        }

        render(
          <ErrorBoundary text={configKey || '6000'}>
            <App dataProvider={DataService} config={config} configKey={configKey} />
          </ErrorBoundary>,
          document.getElementById('app')
        );
      })
      .catch(error => {
        console.error(`Top Level Error: ${error.message || 'Unknown message'}`);
        ReactGA.exception({
          description: `${error.message}`,
          fatal: true
        });

        render(
          <ErrorBoundary error={error} text={configKey || '6000'} />,
          document.getElementById('app')
        );
      });
  } catch (e) {
    console.error(`Initial Error: ${e.message || 'Unknown message'}`);
    ReactGA.exception({
      description: `${e}`,
      fatal: true
    });
  }
};

main();
